import { Box, styled, Typography } from '@mui/material';

const Unauthorized = () => {
  return (
    <StyledWrapperBox>
      <StyledErrorBox>
        <Typography variant="h3" gutterBottom>
          Je hebt onvoldoende rechten om deze pagina te zien.
        </Typography>
        <Typography variant="body1">Vraag een administrator om je te helpen.</Typography>
      </StyledErrorBox>
    </StyledWrapperBox>
  );
};

const StyledWrapperBox = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const StyledErrorBox = styled(Box)(() => ({
  width: '50%',
  maxWidth: '450px',
  textAlign: 'center',
}));

export { Unauthorized };
